import React, { useState } from 'react';
import ShareContentToolbar from '../../../news_show/share_content_toolbar/share_content_toolbar';
import styles from './event_details_share_toolbar_hoc.module.scss';
import { AlertDataType } from '../../../components/react/alert_popup/types';
import AlertPopup from '../../../components/react/alert_popup/alert_popup';
const TARGET_TYPE = 'Event';

interface Props {
  contentId: number;
  contentUrl: string;
  contentTitle: string;
  contentTeaser: string;
}

const EventDetailsShareToolbarHOC = (props: Props): JSX.Element => {
  const [alertData, setAlertData] = useState<AlertDataType|null>(null);

  const {
    contentId,
    contentUrl,
    contentTitle,
    contentTeaser,
  } = props;

  const renderDesktopToolbar: JSX.Element = (
    <div className={`${styles.desktop} d-none d-lg-block d-print-none`}>
      <div className={styles.desktopToolbar} data-testid='event-details-desktop-share-toolbar'>
        <ShareContentToolbar
          contentId={contentId}
          contentUrl={contentUrl}
          contentTitle={contentTitle}
          contentTeaser={contentTeaser}
          displayDevexShareFeature={false}
          displayPrintIcon={false}
          targetType={TARGET_TYPE}
          setAlertData={setAlertData}
        />
      </div>
    </div>
  );

  const renderMobileToolbar: JSX.Element = (
    <div
      className={`
        align-items-center d-inline-flex d-lg-none d-print-none text-center mb-3 mt-4
        ${styles.mobile}
      `}
      data-testid='event-details-mobile-share-toolbar'
    >
      <ShareContentToolbar
        contentId={contentId}
        contentUrl={contentUrl}
        contentTitle={contentTitle}
        contentTeaser={contentTeaser}
        displayDevexShareFeature={false}
        displayPrintIcon={false}
        targetType={TARGET_TYPE}
        setAlertData={setAlertData}
      />
    </div>
  );

  return (
    <>
      <AlertPopup alertData={alertData} setAlertData={setAlertData} />
      {renderDesktopToolbar}
      {renderMobileToolbar}
    </>
  );
};

export default EventDetailsShareToolbarHOC;
